import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "../QuestionPage/AudioPlayer";

import { useState, useEffect } from "react";
import MockNavigation from "./MockNavigation";

// Fetching Data from the API]

// End

// Page Html
export default function TestIntroductionPage() {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [audioLink, setaudioLink] = useState("");

  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h1 className="text-2xl pt-3 font-bold text-gray-900 sm:text-3xl ml-1 text-center md:text-start">
          Test Introduction
        </h1>
        <p className="p-2">
          This test measures the Reading, Writing, Listening and Speaking skills
          in English that you will need in an academic setting.
          <br></br>
          <span>
            1. The test is divided into 3 parts. Each part may contain a number
            of sections. The sections are individually timed. The timer will be
            shown in the top right corner of your screen. The number of items in
            the section will also be displayed.
          </span>
          <br></br>
          <span>
            2. At the beginning of each part you will receive instructions.
            These will provide details on what to expect in that part of the
            test.
          </span>
          <br></br>
          <span>
            3. By clicking on the Next (N) button at the bottom of each screen
            you confirm your answer and move to the next question. If you click
            on Next (N) you will not be able to return to the previous question.
            You will not be able to revisit any question at the end of the test.
          </span>
          <span>
          <br></br>

            4. This test makes use of different varieties of English, for
            example, British, American, Australian. You can answer in the
            standard English variety of your choice.
          </span>
          <span>
          <br></br>

            5. During the test, do not click on any browser buttons (front,
            back, or reload). If you want to leave in between any sections, just
            use Save & Exit button. And if you want to leave after finshing a
            section, just use Save and Exit button.{" "}
          </span>
        </p>
   
     
      </div>
    </div>
  );
}
